var __TEMP__ = require('./clamp.js');var clamp = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./inRange.js');var inRange = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./random.js');var random = __REQUIRE_DEFAULT__(__TEMP__);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  clamp, inRange, random
};
